<template>
<router-view></router-view>
</template>

<script>
export default {
    name: 'App',
    components: {}
}
</script>

<style lang="scss">
.spinner-tbody {
    position: relative;
}

.spinner-wrap {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.loading-data-table {
    min-height: 70vh;
}

.td-custom-height {
    height: 1em;
}

.format-p {
    height: 100%;
    margin: 0;
    display: flex;
    align-items: center;

    &-center {
        justify-content: center;
    }
}

.no-data-list{
  position: relative;
}

.no-data-msg{
  width: 100%;
    position: absolute;
    text-align: center;
    padding: 50px 0;

  p{
    font-size: 20px;
  }
}
</style>
